import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ViewCell} from '@mominsamir/ngx-smart-table';
import {Router} from '@angular/router';
import {NbTooltipDirective, NbTrigger} from '@nebular/theme';

//TODO: this is temporary until we have a proper link component, and changes are made in api level to use query params instead of state.
//ToDo: shared component should not contain specific values mocked (such as maintenance-planning, tooltip text) -> should be refactored

@Component({
    selector: 'ngx-anchor-link-cell',
    template: `
        <a
            *ngIf="value && value !== '/'"
            (click)="navigate()"
            [attr.target]="openInNewTab ? '_blank' : null"
            (mouseenter)="showTooltip()"
            (mouseleave)="closeTooltip()"
            [nbTooltip]="tooltip(rowData)"
            [nbTooltipTrigger]="NbTrigger.NOOP"
        >
            <nb-icon icon="external-link-outline" class="mr-1"></nb-icon>
            {{ value }}
        </a>
    `,
    styleUrls: ['./anchor-link-cell.component.scss'],
})
export class AnchorLinkCellComponent implements ViewCell, OnInit {
    @ViewChild(NbTooltipDirective, {static: false}) tooltipDirective: NbTooltipDirective;
    readonly NbTrigger = NbTrigger;

    @Input() value: any;
    @Input() rowData: any;
    @Input() openInNewTab: boolean = true;
    @Input() queryParamsFields: string[] = [];

    url: string;
    tooltip = (rowData: any): string => '';

    private routerQueryParams: Record<string, string> = {fromPage: 'maintenance-list', pageType: 'VIEW'};

    constructor(private router: Router) {}

    ngOnInit() {
        if (this.rowData) {
            this.routerQueryParams = this.queryParamsFields.reduce((acc, field) => {
                return {...acc, [field]: this.rowData[field]};
            }, this.routerQueryParams);
            this.url = `/maintenance-planning/inspection/${this.rowData.inspectionResultId}`;
            this.tooltip = () => 'Go to Inspection Form';
        }
    }

    navigate(): void {
        const tree = this.router.createUrlTree([this.url], {
            queryParams: this.routerQueryParams,
        });

        const serialized = this.router.serializeUrl(tree);

        if (this.openInNewTab) {
            // Add '#' if using HashLocationStrategy
            const fullUrl = `#${serialized}`;
            window.open(fullUrl, '_blank');
        } else {
            this.router.navigateByUrl(tree);
        }
    }

    showTooltip() {
        if (this.tooltip(this.rowData)) this.tooltipDirective.show();
    }

    closeTooltip() {
        if (this.tooltip(this.rowData) && this.tooltipDirective.isShown) this.tooltipDirective.hide();
    }
}
